export const routes = {
  AUTH_PAGE: '/',
  DASHBOARD_PAGE: '/dashboard',
};
